export const environment = {
    captcha: {
        apiUrl: 'https://preprod-b.egylis.com/captcha/api/captcha',
        timeout_sec: 61
    },
    api: {
        basePath: 'https://preprod-b.egylis.com/rappelStellantis'
    },
    baseUrl: 'https://preprod-b.egylis.com/export_php/Cordova/Stellantis/CampagneRappelV3/'
};
